import React from 'react';
import {Route} from 'react-router';
import auth from '../../utils/auth';

const handleAuthentication = async ({history}: any) => {
  if (/access_token|id_token|error/.test(history.location.hash)) {
    await auth.handleAuthentication();
  }
  history.push('/orders-history');
};

const CallbackRoute: React.FC<any> = ({component: Component, path}) => {
  return (
    <Route
      path={path}
      render={props => {
        handleAuthentication({history: props.history});
        return <Component {...props} />;
      }}
    />
  );
};

export default CallbackRoute;



// WEBPACK FOOTER //
// ./src/components/CallbackRoute/CallbackRoute.tsx